import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 21,
    marginTop: 25,
    marginBottom: 5,
    fontWeight: 700,
    lineHeight: '25.41px',
    color: theme.palette.grey[900],
  },
  subtitle: {
    color: theme.palette.grey[500],
  },
}));

type Props = {
  title: string;
  subtitle?: string;
};

const HeadingTitle = (props: Props) => {
  const classes = useStyles();
  const {title, subtitle} = props;

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>{title}</h1>
      {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
    </div>
  );
};

HeadingTitle.defaultProps = {
  subtitle: '',
};

export default HeadingTitle;
